__turbopack_context__.v({
  "ProductCurrentCard": "TnsqJG_ProductCurrentCard",
  "ProductCurrentCard__Button": "TnsqJG_ProductCurrentCard__Button",
  "ProductCurrentCard__ButtonText": "TnsqJG_ProductCurrentCard__ButtonText",
  "ProductCurrentCard__Container": "TnsqJG_ProductCurrentCard__Container",
  "ProductCurrentCard__Description": "TnsqJG_ProductCurrentCard__Description",
  "ProductCurrentCard__DescriptionWrapper": "TnsqJG_ProductCurrentCard__DescriptionWrapper",
  "ProductCurrentCard__Image": "TnsqJG_ProductCurrentCard__Image",
  "ProductCurrentCard__LogoImageWrapper": "TnsqJG_ProductCurrentCard__LogoImageWrapper",
  "ProductCurrentCard__ProductImageWrapper": "TnsqJG_ProductCurrentCard__ProductImageWrapper",
});
